/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_MoreInputs */



/**
* | output |
* | --- |
* | "Learn More" |
*
* @param {Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const learn_more = /** @type {((inputs?: Learn_MoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_MoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En savoir plus")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehr erfahren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Saperne di più")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Узнать больше")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más información")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("了解更多")
	if (locale === "ja") return /** @type {LocalizedString} */ ("もっと詳しく知る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("और अधिक जानें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saber mais")
	return /** @type {LocalizedString} */ ("Learn More")
});